import React, { useState, useEffect } from 'react';
import {
  PageHeader, Row, Col, Typography, Button, Space, Modal, Result
} from 'antd';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Breadcrumb from 'components/BreadCrumb';
import { fetchRecipeWithSpecifications } from 'utils/recipes';
import Skeleton from 'components/Spins/Skeleton';
import FinalSpecification from 'containers/specifications/final';
import {
  officialTextsHead, OFFICIALTEXTSCONTENT, SIMULANTS_LIST_TEXT, getCodeHtml
} from 'containers/specifications/generationFlow/SpecificationFlow';
import DownLoadPDF from 'components/pdf/download';
import ModalForm from 'containers/mailing/ModalFrom';
import SendCDC from 'containers/mailing/SendCDC';
import { getIngredientDetails, sendSpecification } from 'utils/mails';
import AuthenticatorWithEmail from 'utils/authentificator';

const {
  Title, Paragraph, Text
} = Typography;

const SpecificationDetails = props => {
  const [recipe, setRecipe] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const { match: { params: { recipeId, specificationId } } } = props;

  // eslint-disable-next-line consistent-return
  const onFinish = async result => {
    await sendSpecification(recipe, specificationId, result);
    setIsModalVisible(false);
    setIsConfirmModalVisible(true);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleConfirmOk = () => {
    setIsConfirmModalVisible(false);
  };

  useEffect(async () => {
    if (recipeId) {
      const currentRecipe = await fetchRecipeWithSpecifications(recipeId) || {};
      setRecipe(currentRecipe);
    }
  }, []);

  const getSpecificationDetails = () => {
    const {
      specificationToDetail, details, ingredients, name
    } = getIngredientDetails(recipe, specificationId);
    if (_.isEmpty(specificationToDetail)) return false;
    return (
      <>
        <Modal
          title="Félicitation"
          visible={isConfirmModalVisible}
          onOk={handleConfirmOk}
          footer={[
            <Button key="submit" type="primary" onClick={handleConfirmOk}>
              Fermer
            </Button>,
          ]}
        >
          <Result
            status="success"
            title="Votre devis a été envoyé. Notre équipe vous contactera rapidement."
          />
        </Modal>
        <ModalForm Form={SendCDC} onFinish={onFinish} handleOk={handleOk} isModalVisible={isModalVisible} />
        <PageHeader
          style={{ border: '1px solid #d9d9d9' }}
          title={`Cahier des charges ${specificationToDetail?.name}` || 'Sans nom'}
          breadcrumb={(
            <Breadcrumb
              items={[
                ['Accueil', '/'],
                ['Mes recettes', '/recipes'],
                [`${recipe?.data?.getFormula?.name}`, `/recipe/${recipe?.data?.getFormula?.id}/details`],
                ['Détails cahier des charges'],
              ]}
            />
          )}
        />
        {officialTextsHead()}
        <Row justify="center">
          <Col xs={24} sm={24} md={22} lg={22} xl={22}>
            <Title level={4}>Gestion des migrations</Title>
            <Paragraph style={{ marginTop: '20px' }}>
              {SIMULANTS_LIST_TEXT}
              <Text>
                {recipe?.data?.getFormula?.name}
              </Text>
            </Paragraph>
            <Paragraph style={{ marginTop: '20px' }}>
              {OFFICIALTEXTSCONTENT}
              {getCodeHtml(ingredients)}
            </Paragraph>
            {details?.cdcType && (
              <FinalSpecification details={details} />
            )}
          </Col>
        </Row>
        <Row justify="center" style={{ paddingTop: '20px' }}>
          <Space wrap align="start" size="small" style={{ marginTop: '20px' }}>
            <Col>
              <DownLoadPDF
                recipeIngredient={ingredients}
                detailsSpecification={details}
                id={name}
                recipe={recipe?.data?.getFormula?.name}
              />
            </Col>
            <Col>
              <Button type="primary" onClick={showModal}>Demander un devis</Button>
            </Col>
          </Space>
        </Row>
      </>
    );
  };

  return (
    <AuthenticatorWithEmail>
      {!recipe && (
        <Skeleton />
      )}
      {getSpecificationDetails()}
    </AuthenticatorWithEmail>
  );
};

SpecificationDetails.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      recipeId: PropTypes.string,
      specificationId: PropTypes.string
    })
  }),
  history: PropTypes.shape({
    replace: PropTypes.func
  })
};

export default SpecificationDetails;
